import React from "react";
import List from "../generic/List";
import { sortItemsByLabel } from "../../utils/CompareUtils";
import CopyIcon from "../generic/CopyIcon";

interface TemplateListProps {
    items?: { id: number; label: string; public?: boolean }[];
    onEdit: (id: number | undefined, currentLabel: string) => void;
    onDelete: (id: number) => void;
    onDuplicate: (id: number | undefined, currentLabel: string) => void; // Added onDuplicate prop
}

const TemplateList: React.FC<TemplateListProps> = ({ items = [], onEdit, onDelete, onDuplicate }) => {
    const sortedItems = sortItemsByLabel(items);

    return (
        <div className="w-full py-4">
            <List
                items={sortedItems}
                onEdit={(item) => onEdit(item.id, item.label)}
                onDelete={(item) => {
                    if (item.id !== undefined) {
                        onDelete(item.id);
                    }
                }}
                usePagination={true}
                renderItem={(item) => (
                    <div className="p-4">
                        <div className="text-gray-600 dark:text-gray-400 text-sm">
                            Template ID: <span className="text-sm">{item.id}</span>
                        </div>
                        <div>
                            <span className={"text-gray-700 dark:text-gray-200 text-2xl"}>{item.label}</span>
                            <button
                                className={"shadow-none"}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    onDuplicate(item.id, item.label);
                                }}
                                title="Duplicate"
                            >
                                <CopyIcon />
                            </button>
                        </div>
                    </div>
                )}
                allowDelete={true}
            />
        </div>
    );
};

export default TemplateList;
